/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type AuthDialog_user$ref = any;
export type DropDownAutoComplete_user$ref = any;
export type DropDownAutoComplete_user = {
    readonly id: string;
    readonly userId: string | null;
    readonly publicId: string | null;
    readonly permissions: ({
        readonly id: string;
        readonly oneCommerce: ({
            readonly id: string;
            readonly ceo: ({
                readonly access: boolean | null;
            }) | null;
        }) | null;
    }) | null;
    readonly shoppingWithCeoUser: ({
        readonly publicId: string | null;
    }) | null;
    readonly DropDownAutoCompleteData: ({
        readonly edges: ReadonlyArray<({
            readonly cursor: string;
            readonly node: ({
                readonly id: string;
                readonly isCEO: boolean | null;
                readonly image: string | null;
                readonly ceoId: string | null;
                readonly isEvent: boolean | null;
                readonly isProduct: boolean | null;
                readonly routePath: string | null;
                readonly primaryLabel: string | null;
                readonly secondaryLabel: string | null;
                readonly productCategory: string | null;
            }) | null;
        }) | null> | null;
    }) | null;
    readonly " $fragmentRefs": AuthDialog_user$ref;
    readonly " $refType": DropDownAutoComplete_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "publicId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "DropDownAutoComplete_user",
        "type": "User",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "DropDownAutoCompleteData"
                    ]
                }
            ]
        },
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "ceoId",
                "type": "String",
                "defaultValue": "none"
            },
            {
                "kind": "LocalArgument",
                "name": "inputValue",
                "type": "String",
                "defaultValue": null
            },
            {
                "kind": "LocalArgument",
                "name": "searchCEOS",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "searchEvents",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "searchProducts",
                "type": "Boolean",
                "defaultValue": false
            }
        ],
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "AuthDialog_user",
                "args": null
            },
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "userId",
                "args": null,
                "storageKey": null
            },
            (v1 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "permissions",
                "storageKey": null,
                "args": null,
                "concreteType": "PermissionsType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "oneCommerce",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OneCommerceType",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ceo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AccessType",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "access",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "shoppingWithCeoUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v1 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": "DropDownAutoCompleteData",
                "name": "__DropDownAutoComplete_DropDownAutoCompleteData_connection",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "ceoId",
                        "variableName": "ceoId",
                        "type": "String"
                    },
                    {
                        "kind": "Variable",
                        "name": "inputValue",
                        "variableName": "inputValue",
                        "type": "String"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchCEOS",
                        "variableName": "searchCEOS",
                        "type": "Boolean"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchEvents",
                        "variableName": "searchEvents",
                        "type": "Boolean"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchProducts",
                        "variableName": "searchProducts",
                        "type": "Boolean"
                    }
                ],
                "concreteType": "AutoCompleteEntryConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AutoCompleteEntryEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AutoCompleteDataEntry",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isProduct",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "image",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "ceoId",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isEvent",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isCEO",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "routePath",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "primaryLabel",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "secondaryLabel",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "productCategory",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "__typename",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '8f9e1da3e36e4abbca330d3ad7c5e6f7';
export default node;
